"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var CategoryTitle_1 = __importDefault(require("containers/Navbar/styles/CategoryTitle"));
var AddCharge_1 = __importDefault(require("containersRechargly/Modals/AddCharge"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var RechargesDropdown = function (_a) {
    var recharges = _a.recharges;
    var _b = __read(react_1.default.useState(false), 2), showAddCharge = _b[0], setShowAddCharge = _b[1];
    var history = (0, react_router_1.useHistory)();
    var today = new Date();
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var confirm = (0, hooks_1.useConfirm)();
    var downloadCharges = function (filterCharges) { return function () {
        var rechargesData = !filterCharges
            ? recharges
            : recharges.filter(function (r) { return r.payDate && new Date(r.payDate) >= (0, date_fns_1.sub)(today, { months: 3 }) && new Date(r.payDate) <= today; });
        if (!rechargesData || rechargesData.length <= 0) {
            confirm('No charges  found.', '', 'red', 'OK', true);
            return;
        }
        (0, utils_1.exportCharges)(rechargesData, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Charges").concat(filterCharges ? 'Last 3M' : '', " ").concat((0, end2end_1.getISODate)(today), ".csv"));
    }; };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showAddCharge && (0, jsx_runtime_1.jsx)(AddCharge_1.default, { onClose: function () { return setShowAddCharge(false); } }), (0, jsx_runtime_1.jsxs)(DropdownWithExpandBtn_1.default, __assign({ closeOnClick: true }, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Add single charge", autoFocus: true, onClick: function () { return setShowAddCharge(true); } }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Plan exclusions", autoFocus: true, onClick: function () { return history.push('/recharges/charges/exclude-plans'); } }), (0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {}), (0, jsx_runtime_1.jsx)(CategoryTitle_1.default, __assign({ px: 2 }, { children: "Exports" })), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Export charges", onClick: downloadCharges(false) }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Export charges last 3M", onClick: downloadCharges(true) })] }))] }));
};
exports.default = RechargesDropdown;
